<template>
    <v-row no-gutters>
        <v-col cols="3" class="px-2 pr-2" v-if="displayTypeInput && !$vuetify.display.mobile">
            <v-select
                v-model="type_"
                :items="typesListResolve"
                :disabled="disabled"
                label="Filtrer par type"
                item-filter="filter"
                data-cy="osserFilterBar-type"
                variant="solo"
                density="compact"
                :item-title="(item: any) => item.text"
            />
        </v-col>
        <v-col :cols="!(displayTypeInput && !$vuetify.display.xs) ? '12' : '9'">
            <v-text-field
                v-model="text_"
                :disabled="disabled"
                hide-details
                block
                label="Recherche"
                type="text"
                density="compact"
                :class="fieldClass"
                data-cy="ossFilterBar-search"
                clearable
            >
                <template #append-inner>
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        offset-y
                        left
                        bottom
                        elevation="1"
                    >
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                elevation="0"
                                icon="$tune"
                                size="small"
                                style="margin-top: -2px"
                                v-bind="props"
                                data-cy="ossFilterBar-dialog"
                            />
                        </template>

                        <v-card
                            :class="{ 'pa-3 pb-0': true, 'mt-3': $vuetify.display.mobile }"
                            elevation="1"
                            :style="{ width: !$vuetify.display.mobile ? '700px' : undefined }"
                        >
                            <v-window v-model="wizardStepSelectCompany" touchless>
                                <v-window-item :value="0">
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <h3>Filtres</h3>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="py-2">
                                        <v-col
                                            :cols="$vuetify.display.mobile ? '12' : '4'"
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-if="displayTypeInput"
                                            data-cy="ossFilterBar-type"
                                        >
                                            <v-select-filled
                                                v-model="type_"
                                                outlined
                                                :items="typesListResolve"
                                                label="Filtrer par type"
                                                item-filter="filter"
                                                :hide-details="true"
                                                :disabled="disabled"
                                                data-cy="ossFilterBar-type"
                                                density="compact"
                                                :item-title="(item: any) => item.text"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="$vuetify.display.mobile ? '12' : '4'"
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-if="displayStatusInput"
                                        >
                                            <v-select-filled
                                                outlined
                                                v-model="status_"
                                                :items="statusListResolve"
                                                label="Filtrer par statut"
                                                item-filter="filter"
                                                :hide-details="true"
                                                :disabled="disabled"
                                                data-cy="ossFilterBar-status"
                                                density="compact"
                                                item-title="text"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="$vuetify.display.mobile ? '12' : '4'"
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-if="displayThirdPartyCompanyInput"
                                        >
                                            <v-text-field-filled
                                                outlined
                                                label="Filtrer par société"
                                                :hide-details="true"
                                                :disabled="
                                                    disabled ||
                                                    (type_ !== 'SALES_INVOICE' &&
                                                        type_ !== 'PURCHASE_INVOICE' &&
                                                        type_ !== 'MAIL')
                                                "
                                                @click.stop="selectCompanyPanel()"
                                                readonly
                                                :model-value="tpCompanyName"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="$vuetify.display.mobile ? '12' : '4'"
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-else-if="auditChecks"
                                        >
                                            <v-select-filled
                                                outlined
                                                v-model="auditCheck_"
                                                :items="auditChecks"
                                                label="Contrôles"
                                                item-filter="filter"
                                                :hide-details="true"
                                                :disabled="disabled"
                                                density="compact"
                                                :item-title="(item: any) => item.text"
                                                data-cy="OssFilterBar-AuditCheckSelect-Select"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        :class="$vuetify.display.mobile ? '' : 'py-2'"
                                        v-if="
                                            displayTagsInput ||
                                            (displayThirdPartyCompanyInput && auditChecks)
                                        "
                                    >
                                        <v-col cols="4" class="px-1" v-if="displayTagsInput">
                                            <oss-tags-selector-filled
                                                v-model="tags_"
                                                :items="usedTags"
                                                :label="'Filtrer par étiquettes'"
                                                :disabled="disabled"
                                                prefixDataCy="OssFilterBar-etiquettes"
                                                item-title="text"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="$vuetify.display.mobile ? '12' : '4'"
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-if="displayThirdPartyCompanyInput && auditChecks"
                                        >
                                            <v-select-filled
                                                outlined
                                                v-model="auditCheck_"
                                                :items="auditChecks"
                                                label="Contrôles"
                                                item-filter="filter"
                                                :hide-details="true"
                                                :disabled="disabled"
                                                density="compact"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="$vuetify.display.mobile ? '12' : '4'"
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-if="partitionTags"
                                        >
                                            <v-select-filled
                                                outlined
                                                v-model="partitionTagId_"
                                                :items="partitionTags"
                                                item-value="id"
                                                label="Sans partition"
                                                item-filter="filter"
                                                :hide-details="true"
                                                :disabled="disabled"
                                                density="compact"
                                                :item-title="(item) => item.name"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="$vuetify.display.mobile ? '12' : '4'"
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-if="displayStatusInput && !displayTagsInput"
                                        >
                                            <v-select-filled
                                                outlined
                                                v-model="declaredStatus_"
                                                :items="declaredStatusListResolve"
                                                label="Déclaré / Non Déclaré"
                                                item-filter="filter"
                                                :hide-details="true"
                                                :disabled="disabled"
                                                density="compact"
                                                item-title="text"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        :class="$vuetify.display.mobile ? '' : 'py-2'"
                                    >
                                        <v-col
                                            :cols="
                                                $vuetify.display.mobile
                                                    ? '12'
                                                    : displaySwitchGraph
                                                      ? '3'
                                                      : '4'
                                            "
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-if="displayStatusInput && displayTagsInput"
                                        >
                                            <v-select-filled
                                                outlined
                                                v-model="declaredStatus_"
                                                :items="declaredStatusListResolve"
                                                label="Déclaré / Non Déclaré"
                                                item-filter="filter"
                                                :hide-details="true"
                                                :disabled="disabled"
                                                density="compact"
                                                item-title="text"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="
                                                $vuetify.display.mobile
                                                    ? '6'
                                                    : displaySwitchGraph
                                                      ? '3'
                                                      : '4'
                                            "
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-if="displayDateRange"
                                        >
                                            <oss-date-picker-filled
                                                v-model="startDate_"
                                                label="Date de début"
                                                hide-details
                                                :textFieldReadOnly="false"
                                                :minDate="minDate"
                                                :disabled="disabled"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="
                                                $vuetify.display.mobile
                                                    ? '6'
                                                    : displaySwitchGraph
                                                      ? '3'
                                                      : '4'
                                            "
                                            :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                            v-if="displayDateRange"
                                        >
                                            <oss-date-picker-filled
                                                v-model="endDate_"
                                                label="Date de fin"
                                                hide-details
                                                :textFieldReadOnly="false"
                                                :maxDate="maxDate"
                                                :disabled="disabled"
                                            />
                                            <!-- <oss-date-range-picker
                                                :begin="startDate_"
                                                :end="endDate_"
                                                :filterWithSelectedAccountingPeriod="true"
                                                :cyPrefix="'bank'"
                                                @change-dateRange="onDateRangeChanged"
                                                :hideDetails="true"
                                                dense
                                                textFieldClass="oss-"
                                                lable="Filtrer par date"
                                            ></oss-date-range-picker> -->
                                        </v-col>
                                        <v-col class="d-flex align-center">
                                            <v-switch
                                                v-if="displaySwitchGraph"
                                                class="ml-4 mt-0 pt-0"
                                                v-model="displayGraph_"
                                                :label="
                                                    startDate_ && endDate_
                                                        ? 'Afficher le graphique des flux bancaires'
                                                        : 'Sélectionnez une période pour afficher le graphique des flux bancaires'
                                                "
                                                hide-details
                                                :disabled="!startDate_ || !endDate_"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        v-if="type_ !== 'MAIL'"
                                        no-gutters
                                        :class="$vuetify.display.mobile ? '' : 'py-2'"
                                    >
                                        <v-col
                                            md="5"
                                            cols="12"
                                            class="px-1"
                                            v-if="displayMinAmount || displayMaxAmount"
                                        >
                                            <v-row v-if="filterWithTolerance" no-gutters>
                                                <v-col cols="6">
                                                    <oss-text-field-filled
                                                        v-model="amountForTolerance"
                                                        :label="`Montant`"
                                                        outlined
                                                        dense
                                                        :true-input="true"
                                                        hide-details
                                                        suffix="&#x20ac;"
                                                        data-cy="ossFilterBar-minAmount"
                                                        :disabled="disabled"
                                                    />
                                                </v-col>
                                                <v-col cols="6">
                                                    <oss-text-field-filled
                                                        v-model="tolerance"
                                                        :label="`Tolérance`"
                                                        outlined
                                                        dense
                                                        :true-input="true"
                                                        hide-details
                                                        suffix="&#x20ac;"
                                                        data-cy="ossFilterBar-minAmount"
                                                        :disabled="disabled"
                                                    />
                                                </v-col>
                                            </v-row>
                                            <v-row
                                                no-gutters
                                                style="
                                                    background-color: #ececec;
                                                    border-radius: 15px;
                                                "
                                                v-else
                                            >
                                                <v-col class="py-0" v-if="displayMinAmount">
                                                    <oss-text-field-filled
                                                        v-model="minPrice_"
                                                        :label="`Min ${
                                                            limitMinPrice
                                                                ? '(' +
                                                                  newCommonFormatCurrency(
                                                                      limitMinPrice,
                                                                      undefined,
                                                                  ) +
                                                                  ')'
                                                                : ''
                                                        }`"
                                                        outlined
                                                        dense
                                                        :true-input="true"
                                                        hide-details
                                                        suffix="&#x20ac;"
                                                        data-cy="ossFilterBar-minAmount"
                                                        :disabled="disabled"
                                                    />
                                                </v-col>
                                                <v-col
                                                    cols="1"
                                                    class="py-0 d-flex align-center justify-center"
                                                    v-if="displayMinAmount && displayMaxAmount"
                                                >
                                                    <v-icon>$chevron-left</v-icon>
                                                </v-col>
                                                <v-col class="py-0">
                                                    <oss-text-field-filled
                                                        v-if="displayMaxAmount"
                                                        v-model="maxPrice_"
                                                        :label="`Max ${
                                                            limitMaxPrice
                                                                ? '(' +
                                                                  newCommonFormatCurrency(
                                                                      limitMaxPrice,
                                                                      undefined,
                                                                  ) +
                                                                  ')'
                                                                : ''
                                                        }`"
                                                        outlined
                                                        dense
                                                        :true-input="true"
                                                        hide-details
                                                        suffix="&#x20ac;"
                                                        data-cy="ossFilterBar-maxAmount"
                                                        :disabled="disabled"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="3"
                                            class="px-1 d-flex align-center justify-center"
                                        >
                                            <v-switch
                                                v-model="filterWithTolerance"
                                                class="mt-0 pt-0 pl-2"
                                                hide-details
                                            >
                                                <template v-slot:label>
                                                    <span class="caption">
                                                        Filtrer avec tolérance
                                                    </span>
                                                </template>
                                            </v-switch>
                                        </v-col>
                                        <v-col
                                            md="4"
                                            cols="6"
                                            class="px-1"
                                            v-if="payByList && payByList.length"
                                        >
                                            <v-select-filled
                                                v-model="payBy_"
                                                :items="payByList"
                                                label="Mode de paiement"
                                                outlined
                                                hide-details
                                                :disabled="disabled"
                                                density="compact"
                                                item-title="text"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item :value="1">
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-btn-icon
                                                icon
                                                size="small"
                                                @click.stop="wizardStepSelectCompany = 0"
                                            />
                                        </v-col>
                                        <v-col cols="12" v-if="companyId">
                                            <CompaniesTable
                                                :showGenericCompany="false"
                                                :showConsumerCompany="type_ === 'SALES_INVOICE'"
                                                :showCustomerCompanies="
                                                    type_ === 'SALES_INVOICE' || type_ === 'MAIL'
                                                "
                                                :showSupplierCompanies="
                                                    type_ === 'PURCHASE_INVOICE' || type_ === 'MAIL'
                                                "
                                                :showExistingCompanies="false"
                                                :showNewCompanies="false"
                                                :company="
                                                    thirdPartyCompanyName_
                                                        ? thirdPartyCompanyName_
                                                        : ''
                                                "
                                                :parentCompanyId="companyId"
                                                :wizardMode="true"
                                                @select-company="companySelected"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                            </v-window>
                            <v-divider />
                            <v-card-actions class="d-flex justify-space-between">
                                <v-btn-reset
                                    @click.stop="clearMenu()"
                                    data-cy="ossFilterBar-resetFilter"
                                    size="small"
                                >
                                </v-btn-reset>
                                <v-btn
                                    @click="menu = false"
                                    data-cy="ossFilterBar-validate"
                                    size="small"
                                    variant="tonal"
                                >
                                    Valider
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </template>
            </v-text-field>
        </v-col>
        <v-col cols="12">
            <v-chip-group>
                <!-- Date -->
                <template
                    v-if="dbStartDate && dbEndDate && !selectedAccountingClosing && !auditCheck_"
                >
                    <v-chip
                        class="ma-2"
                        color="primary"
                        label
                        size="small"
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon size="small" location="start">$oss-calendar</v-icon>
                        Du {{ formatDate(dbStartDate) }} au {{ formatDate(dbEndDate) }}
                        <v-icon
                            right
                            size="small"
                            @click="removeDateFilter"
                            v-if="!dateIsManadatory"
                            >$close</v-icon
                        >
                    </v-chip>
                </template>

                <template v-else-if="dbStartDate && !selectedAccountingClosing && !auditCheck_">
                    <v-chip
                        size="small"
                        class="ma-2"
                        color="primary"
                        label
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon left size="small">$oss-calendar</v-icon>
                        &#xc0; partir du {{ formatDate(dbStartDate) }}
                        <v-icon
                            right
                            size="small"
                            @click="removeDateFilter"
                            v-if="!dateIsManadatory"
                            >$close</v-icon
                        >
                    </v-chip>
                </template>

                <template v-else-if="endDate_ && !selectedAccountingClosing && !auditCheck_">
                    <v-chip
                        class="ma-2"
                        color="primary"
                        label
                        size="small"
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon size="small" location="start">$oss-calendar</v-icon>
                        Jusqu'au {{ formatDate(dbEndDate) }}
                        <v-icon
                            right
                            size="small"
                            @click="removeDateFilter"
                            v-if="!dateIsManadatory"
                            >$close</v-icon
                        >
                    </v-chip>
                </template>

                <template v-else-if="!!selectedAccountingClosing">
                    <v-chip
                        class="ma-2"
                        color="primary"
                        label
                        size="small"
                        variant="flat"
                        :ripple="false"
                    >
                        {{ selectedAccountingClosing.name }}
                    </v-chip>
                </template>

                <!-- Type -->
                <template v-if="showTypeTag && displayTypeInput && type_ !== 'ALL'">
                    <v-chip
                        size="small"
                        class="ma-2"
                        color="primary"
                        label
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon left size="small">$label</v-icon>
                        {{ $t("filter.type." + type_.split("#")[0]) }}
                        <v-icon right size="small" @click.stop="removeType" v-if="!typeIsManadatory"
                            >$close</v-icon
                        >
                    </v-chip>
                </template>

                <!-- Status -->
                <template v-if="showStatusTag && displayStatusInput && status_ !== 'ALL'">
                    <v-chip
                        class="ma-2"
                        color="primary"
                        label
                        size="small"
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon size="small" location="start">$label</v-icon>
                        {{ statusWording }}
                        <v-icon
                            right
                            size="small"
                            @click.stop="removeStatus"
                            v-if="!statusIsManadatory"
                            >$close</v-icon
                        >
                    </v-chip>
                </template>

                <!-- Declared status -->
                <template v-if="displayDeclaredStatusInput && declaredStatus_ !== 'ALL'">
                    <v-chip class="ma-2" color="primary" label size="small" variant="outlined">
                        <v-icon size="small" location="start">$label</v-icon>
                        {{ declaredStatusWording }}
                        <v-icon right size="small" @click.stop="removeDeclaredStatus"
                            >$close</v-icon
                        >
                    </v-chip>
                </template>

                <!-- Company -->
                <template v-if="tpCompanyName">
                    <v-chip
                        size="small"
                        class="ma-2"
                        color="primary"
                        label
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon left size="small">$fa-building</v-icon>
                        {{ tpCompanyName }}
                        <v-icon right size="small" @click="removeCompany">$close</v-icon>
                    </v-chip>
                </template>
                <template v-if="auditCheck_">
                    <v-chip
                        size="small"
                        class="ma-2"
                        color="primary"
                        label
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon left size="small">$fa-check</v-icon>
                        {{ $t("audit." + auditCheck_ + ".mainTitle") }}
                        <v-icon right size="small" @click="removeAuditCheck">$close</v-icon>
                    </v-chip>
                </template>
                <template v-if="partitionTagId_ !== ''">
                    <v-chip
                        size="small"
                        class="ma-2"
                        color="primary"
                        label
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon left size="small">$fa-check</v-icon>
                        {{ partitionTagTitle }}
                        <v-icon right size="small" @click="removePartitionTag">$close</v-icon>
                    </v-chip>
                </template>
                <!-- Price -->
                <template
                    v-if="
                        minPrice_ &&
                        minPrice_ !== limitMinPrice &&
                        maxPrice_ &&
                        maxPrice_ !== limitMaxPrice
                    "
                >
                    <v-chip
                        size="small"
                        class="ma-2"
                        color="primary"
                        label
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon left size="small">$fa-money-bill-wave</v-icon>
                        Entre {{ minPrice_ }}&#x20ac; et {{ maxPrice_ }}&#x20ac;
                        <v-icon right size="small" @click="removePrice()">$close</v-icon>
                    </v-chip>
                </template>

                <template v-else-if="minPrice_ && minPrice_ !== limitMinPrice">
                    <v-chip
                        size="small"
                        class="ma-2"
                        color="primary"
                        label
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon left size="small">$fa-money-bill-wave</v-icon>
                        Plus de {{ minPrice_ }}&#x20ac;
                        <v-icon right size="small" @click="removePrice()">$close</v-icon>
                    </v-chip>
                </template>

                <template v-else-if="maxPrice_ && maxPrice_ !== limitMaxPrice">
                    <v-chip
                        size="small"
                        class="ma-2"
                        color="primary"
                        label
                        variant="flat"
                        :ripple="false"
                    >
                        <v-icon left size="small">$fa-money-bill-wave</v-icon>
                        Moins de {{ maxPrice_ }}&#x20ac;
                        <v-icon right size="small" @click="removePrice()">$close</v-icon>
                    </v-chip>
                </template>

                <!-- Tags -->
                <template v-if="tags_ && tags_.length">
                    <template v-for="(tag, index) in tags_" :key="index">
                        <v-chip
                            class="ma-2"
                            :color="tag ? `${tag.color}` : ''"
                            :outlined="tag && tag.type === 'SubAccountableAccount'"
                            label
                            size="small"
                            :ripple="false"
                        >
                            <v-icon left size="small">$label</v-icon>
                            {{ tag ? tag.text : "XXX" }}
                            <v-icon right size="small" @click="removeTag(index)">$close</v-icon>
                        </v-chip>
                    </template>
                </template>

                <!-- PayBy -->

                <template v-if="payBy_ && payBy_ !== 'ALL'">
                    <v-chip
                        class="ma-2"
                        color="primary"
                        :outlined="true"
                        label
                        size="small"
                        :ripple="false"
                    >
                        <v-icon left size="small">$label</v-icon>
                        {{ $t(`zTillReceipt.transaction.${payBy_}`) }}
                        <v-icon right size="small" @click="payBy_ = 'ALL'">$close</v-icon>
                    </v-chip>
                </template>
            </v-chip-group>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import _ from "lodash";
import moment from "moment-timezone";
import ossTagsSelector from "./ossTagsSelector.vue";
import { getCompanyTags } from "../../services/tagServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import CompaniesTable from "../admin/CompaniesTable.vue";

import USED_TAG_QUERY from "../../graphql/tag/UsedTags.gql";
import DOCUMENT_USED_TYPES from "../../graphql/document/DocumentUsedTypes.gql";
import USED_DOCUMENT_STATUS from "../../graphql/document/DocumentUsedStatus.gql";

import { Company } from "../../../../types";
import { User } from "../../store/store";
import { getDBFormattedDate, getDBFormattedStartDate } from "../../services/dateServices";
import { mathFix } from "@/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { getCurrentInstance } from "vue";

@Component({
    components: {
        ossTagsSelector,
        CompaniesTable,
    },
    emits: ["clear-filter", "thirdPartyCompany"],
})
export class ossFilterBar extends Vue {
    @Prop({ default: "" }) fieldClass: string;
    /** Selectable List */
    // @Prop({ default: [] }) tagsList
    @Prop({ default: null }) typesList;
    @Prop({ default: null }) statusList;
    @Prop({ default: null }) limitMaxPrice;
    @Prop({ default: null }) limitMinPrice;
    @Prop({ default: null }) payByList;

    @Prop({ default: true }) showTypeTag;
    @Prop({ default: true }) showStatusTag;

    @Prop({ default: false }) statusIsManadatory;
    @Prop({ default: false }) typeIsManadatory;
    @Prop({ default: false }) dateIsManadatory;

    @Prop() selectedAccount;

    @Prop({ default: null }) auditChecks;

    @Prop({ default: null }) partitionTags;

    @Prop({ default: null }) minDate;
    @Prop({ default: null }) maxDate;

    /** Inputs */

    @Model({ name: "type" }) type_;

    @Model({ name: "status" }) status_;

    @Model({ name: "declaredStatus" }) declaredStatus_;

    @Model({ name: "text" }) text_;

    @Model({ default: null, name: "tags" }) tags_;

    @Model({ name: "startDate" }) startDate_;

    @Model({ name: "endDate" }) endDate_;

    @Model({ name: "thirdPartyCompanyName" }) thirdPartyCompanyName_;

    @Model({ name: "minPrice" }) minPrice_;

    @Model({ name: "maxPrice" }) maxPrice_;

    @Model({ name: "payBy" }) payBy_;

    @Model({ name: "auditCheck" }) auditCheck_;

    @Model({ default: "", name: "partitionTagId" }) partitionTagId_;

    @Model({ default: false, name: "displayGraph" }) displayGraph_;

    /** Default */
    @Prop() companyId;

    get currentProps() {
        // const currentInstance = getCurrentInstance();
        // console.log("currentInstance", currentInstance);
        // return currentInstance?.vnode?.props || {};
        return this.$.vnode?.props || {};
    }

    get selectedAccountingClosing() {
        return this.$store.state.accountingPeriod.selectedAccountingClosing?.id
            ? this.$store.state.accountingPeriod.selectedAccountingClosing
            : null;
    }

    menu = false;
    wizardStepSelectCompany = 0;
    filterWithTolerance = false;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    /** Display */
    get displayTypeInput() {
        return this.typesList && this.typesList.length;
    }

    get isForDocuments() {
        return (
            this.$router.currentRoute.value.name.toString().startsWith("documents") ||
            this.$route.name === "accountingLog" ||
            this.$route.name === "accountingLines"
        );
    }

    get disabled() {
        return !!this.auditCheck_;
        // || !!this.partitionTagId
    }

    tpCompanyName_ = "";

    get tpCompanyName() {
        return this.thirdPartyCompanyName_ || this.tpCompanyName_;
    }

    set tpCompanyName(data) {
        this.tpCompanyName_ = data;
        this.thirdPartyCompanyName_ = data;
    }

    get typesListResolve() {
        if (this.isForDocuments) {
            const types = this.usedTypes
                .filter((ut) => this.typesList.find((t) => t.value === ut.type))
                .map((x) => ({
                    value: x.type + (x.bankAccountId ? "#" + x.bankAccountId : ""),
                    text:
                        (x.bankAccountName
                            ? x.bankAccountName
                            : this.$t("document.type." + x.type)) +
                        " (" +
                        x.count +
                        ")",
                    objectType: x.bankAccountId ? "bankAccount" : "",
                }));

            for (const tag of this.usedTags) {
                if (tag.primaryLog) {
                    const log = {
                        value: tag.primaryLog + "#" + tag.id,
                        text: tag.text + (tag.count ? " (" + tag.count + ")" : ""),
                        objectType: "tag",
                    };
                    const index = types.findIndex((t) => t.value === tag.primaryLog);
                    if (index !== -1) {
                        types.splice(index + 1, 0, log);
                    } else {
                        types.push(log);
                    }
                }
            }

            if (!this.typeIsManadatory) {
                types.splice(0, 0, {
                    value: "ALL",
                    text: this.$t("document.type.ALL").toString(),
                    objectType: "",
                });
            }
            return types;
        }
        return this.typesList;
    }

    get statusListResolve() {
        if (this.isForDocuments) {
            const statusWithCount = this.usedStatus
                .filter((ut) => this.statusList.find((t) => t.value === ut.status))
                .map((x) => ({
                    value: x.status,
                    text: this.$t("document.status." + x.status) + " (" + x.count + ")",
                }));
            const uniq = _.uniqBy(
                [...statusWithCount, ...this.statusList],
                (status) => status.value,
            );
            // debugger
            if (!this.statusIsManadatory) {
                uniq.splice(0, 0, {
                    value: "ALL",
                    text: this.$t("document.status.ALL").toString(),
                });
            }
            return uniq;
        }
        return this.statusList;
    }

    get declaredStatusListResolve() {
        return [
            { value: "ALL", text: "Indifférent" },
            { value: "DECLARED", text: "Déclaré" },
            { value: "UNDECLARED", text: "Non déclaré" },
        ];
    }

    get displayMinAmount() {
        return this.currentProps && this.currentProps["onUpdate:minPrice"];
    }

    get displayMaxAmount() {
        return this.currentProps && this.currentProps["onUpdate:maxPrice"];
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get filterWithTag() {
        return this.currentProps && this.currentProps["onUpdate:tags"] && this.type_ !== "MAIL";
    }

    get displayTagsInput() {
        return !!(this.usedTags && this.usedTags.length && this.filterWithTag);
    }

    get displayDateRange() {
        if (this.selectedAccountingClosing) {
            return false;
        }
        return (
            this.currentProps &&
            this.currentProps["onUpdate:startDate"] &&
            this.currentProps["onUpdate:endDate"]
        );
    }

    get displayStatusInput() {
        return (
            this.type_ !== "MAIL" &&
            this.statusList &&
            this.statusList.length &&
            this.currentProps &&
            this.currentProps["onUpdate:status"]
        );
    }

    get displayDeclaredStatusInput() {
        return (
            this.type_ !== "MAIL" &&
            this.currentProps &&
            this.currentProps["onUpdate:declaredStatus"]
        );
    }

    get displayThirdPartyCompanyInput() {
        return (
            this.currentProps &&
            (this.currentProps["onUpdate:thirdPartyCompanyName"] ||
                this.currentProps["onUpdate:thirdPartyCompany"])
        );
    }

    get displaySwitchGraph() {
        if (this.selectedAccount === "ALL") {
            return false;
        }
        return this.currentProps && this.currentProps["onUpdate:displayGraph"];
    }

    get amountForTolerance() {
        return +this.minPrice_ + (this.tolerance || 0);
    }

    set amountForTolerance(amount) {
        const tolerance = this.tolerance;
        debugger;
        this.minPrice_ = amount - tolerance;
        this.maxPrice_ = amount + tolerance;
    }

    get tolerance() {
        return mathFix((+this.maxPrice_ - +this.minPrice_) / 2) || 0;
    }

    set tolerance(tolerance) {
        const amount = this.amountForTolerance;
        this.minPrice_ = amount - tolerance;
        this.maxPrice_ = amount + tolerance;
    }

    @Watch("selectedAccount")
    resetSwitchGraph() {
        if (this.selectedAccount === "ALL") {
            this.displayGraph_ = false;
        }
    }

    /**  Variables */

    @Watch("tagIdInURL")
    resetTagInURL() {
        // const isInList = this.tags && !!this.tags.filter(x => x && x.id === this.$route.params.tagId).length
        // if (!isInList) {
        if (this.$route.params.tagId) {
            const tag = this.usedTags.find((x) => x.id === this.$route.params.tagId);
            if (tag) {
                this.tags_ = [tag];
                console.log(tag);
                if (tag.primaryLog) {
                    // this.type_ = tag.primaryLog
                    console.log(this.typesListResolve);
                    const value = tag.primaryLog + "#" + tag.id;
                    const type = this.typesListResolve.find((t) => t.value === value);
                    if (type) {
                        this.type_ = value;
                    } else {
                        debugger;
                        this.type_ = tag.primaryLog;
                    }
                }
            }
        }
    }

    get tagIdInURL() {
        return this.$route.params.tagId;
    }

    thirdPartyCompany_ = null;

    get thirdPartyCompany() {
        return this.thirdPartyCompany_;
    }
    set thirdPartyCompany(data) {
        this.$emit("thirdPartyCompany", data);
        this.thirdPartyCompany_ = data;
    }

    get documentStartDate() {
        const date = this.$store.getters.getDocumentStartDate();
        if (!date || !moment(date).isValid()) {
            return undefined;
        }
        return getDBFormattedDate(date);
    }

    get documentEndDate() {
        const date = this.$store.getters.getDocumentEndDate();
        if (!date || !moment(date).isValid()) {
            return undefined;
        }
        return getDBFormattedDate(date);
    }

    @Apollo({
        query() {
            return USED_TAG_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                mode: this.mode,
                startDate: this.documentStartDate,
                endDate: this.documentEndDate,
            };
        },
        debounce: 500,
        skip() {
            return !this.companyId || !this.filterWithTag;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.usedTags = [];
                if (data.usedTags && data.usedTags.tags) {
                    getCompanyTags(this, this.companyId, data.usedTags.tags, this.usedTags);
                }
            }
        },
    })
    usedTags = [];

    @Apollo({
        query: DOCUMENT_USED_TYPES,
        variables() {
            return {
                companyId: this.companyId,
                startDate: this.dbStartDate,
                endDate: this.dbEndDate,
                status: this.$route.name === "accountingLog" ? "VALIDATED" : undefined,
            };
        },
        debounce: 500,
        skip() {
            return !this.companyId || !this.isForDocuments;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.usedTypes = [];
                // debugger
                if (data.documentUsedTypes && data.documentUsedTypes.types) {
                    this.usedTypes = data.documentUsedTypes.types;
                    if (this.documentType !== "ALL") {
                        const index = this.usedTypes.findIndex(
                            (ut) => ut.type === this.documentType,
                        );
                        if (index === -1) {
                            if (this.typeIsManadatory) {
                                if (this.usedTypes.length) {
                                    this.documentType = this.usedTypes[0].type;
                                } else {
                                    this.documentType = "";
                                }
                            } else {
                                this.documentType = "ALL";
                            }
                        }
                    }
                }
            }
        },
    })
    usedTypes = [];

    get dbStartDate() {
        return getDBFormattedStartDate(this.startDate_);
    }

    get dbEndDate() {
        return getDBFormattedStartDate(this.endDate_);
    }

    @Apollo({
        query: USED_DOCUMENT_STATUS,
        variables() {
            return {
                companyId: this.companyId,
                startDate: this.dbStartDate,
                endDate: this.dbEndDate,
            };
        },
        debounce: 500,
        skip() {
            return !this.companyId || this.$route.name !== "documents";
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                // debugger
                if (data && data.documentUsedStatus && data.documentUsedStatus.status) {
                    this.usedStatus = data.documentUsedStatus.status;
                    if (this.status_ !== "ALL") {
                        const index = this.usedStatus.findIndex((ut) => ut.status === this.status_);
                        if (index === -1) {
                            if (this.statusIsManadatory) {
                                if (this.usedStatus.length) {
                                    this.status_ = this.usedStatus[0].status;
                                } else {
                                    this.status_ = "";
                                }
                            } else {
                                this.status_ = "ALL";
                            }
                        }
                    }
                } else {
                    this.usedStatus = [];
                }
            }
        },
    })
    usedStatus = [];

    /** Wordings */
    get statusWording() {
        const item = this.statusList.find((x) => x.value === this.status_);
        return item ? item.text : null;
    }

    get declaredStatusWording() {
        const item = this.declaredStatusListResolve.find((x) => x.value === this.declaredStatus_);
        return item ? item.text : null;
    }

    /** Functions */
    selectCompanyPanel() {
        this.wizardStepSelectCompany = 1;
    }

    formatDate(data) {
        moment.locale("fr");
        return moment(data).format("DD MMMM YYYY");
    }

    companySelected(obj: Company) {
        debugger;
        this.tpCompanyName = obj.name;
        this.thirdPartyCompany_ = obj;
        this.wizardStepSelectCompany = 0;
    }

    onDateRangeChanged(data) {
        // debugger
        this.startDate_ = data.begin;
        this.endDate_ = data.end;
    }

    /** Remove */

    removePrice() {
        this.minPrice_ = "";
        this.maxPrice_ = "";
    }

    removeTag(index) {
        if (this.tags_?.length) {
            this.tags_ = this.tags_.filter((x, i) => i !== index);
        }
    }

    removeTags() {
        if (this.tags_?.length) {
            this.tags_ = [];
        }
    }

    removeDateFilter() {
        if (this.statusIsManadatory) {
            return;
        }
        this.startDate_ = "";
        this.endDate_ = "";
        this.displayGraph_ = false;
    }

    removeCompany() {
        this.tpCompanyName = "";
    }

    removeAuditCheck() {
        this.auditCheck_ = "";
    }

    removePartitionTag() {
        this.partitionTagId_ = "";
    }

    get partitionTagTitle() {
        if (this.partitionTags) {
            const partitionTag = this.partitionTags.find((pt) => pt.id === this.partitionTagId_);
            if (partitionTag) {
                return "A tagguer dans '" + partitionTag.name + "'";
            }
        }
        return "";
    }

    removeType() {
        if (this.typeIsManadatory) {
            return;
        }
        this.type_ = "ALL";
    }

    removeStatus() {
        if (this.statusIsManadatory) {
            return;
        }
        this.status_ = "ALL";
    }

    removeDeclaredStatus() {
        this.declaredStatus_ = "ALL";
    }

    clearMenu() {
        this.removePrice();
        this.removeTags();
        this.removeDateFilter();
        this.removeCompany();
        this.removeType();
        this.removeStatus();
        this.removeAuditCheck();
        this.$emit("clear-filter");
    }

    @Watch("companyId")
    resetFilterByChangingCompany() {
        // debugger
        if (this.tags_ && this.tags_.length) {
            this.tags_ = [];
            this.$router.push({ name: this.$route.name });
        }
        this.removeCompany();
    }
}

export default toNative(ossFilterBar);
</script>
<style lang="scss">
.v-chip:focus,
.v-chip:active {
    background-color: inherit !important;
    color: inherit !important;
    box-shadow: none !important;
    outline: none !important;
}
</style>
